module.exports = __webpack_public_path__ + "img/ALB.bf5d6012.svg";